(() => {
  const FILTER_SELECTOR =
    '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter';

  const isActiveControl = (input) => {
    if (input.matches('input[type="checkbox"], input[type="radio"]')) return input.checked;
    return Boolean(input.value);
  };

  const isPriorityFacet = (element) =>
    Boolean(
      element.querySelector(
        'input[name^="filter."], select[name^="filter."]',
      ),
    );

  const markUnavailable = (element) => {
    const controls = [...element.querySelectorAll('input, select')];
    const hasActiveControl = controls.some(isActiveControl);

    if (hasActiveControl && isPriorityFacet(element)) {
      element.hidden = false;
      element.removeAttribute('aria-hidden');
      element.classList.remove('fa-facet-unavailable');
      element.classList.add('fa-facet-preserved');
      element.dataset.faFacetAvailability = 'preserved';
      controls.forEach((input) => {
        if (!isActiveControl(input)) {
          input.disabled = true;
          input.dataset.faDisabledByPersistence = 'true';
        }
      });
      return;
    }

    element.hidden = true;
    element.setAttribute('aria-hidden', 'true');
    element.classList.add('fa-facet-unavailable');
    element.classList.remove('fa-facet-preserved');
    element.dataset.faFacetAvailability = 'unavailable';

    controls.forEach((input) => {
      if (!input.disabled) {
        input.disabled = true;
        input.dataset.faDisabledByPersistence = 'true';
      }
    });
  };

  const markAvailable = (element) => {
    element.hidden = false;
    element.removeAttribute('aria-hidden');
    element.classList.remove('fa-facet-unavailable', 'fa-facet-preserved');
    element.dataset.faFacetAvailability = 'available';

    element
      .querySelectorAll('[data-fa-disabled-by-persistence="true"]')
      .forEach((input) => {
        input.disabled = false;
        delete input.dataset.faDisabledByPersistence;
      });
  };

  const patch = () => {
    const FacetFiltersForm = customElements.get('facet-filters-form');
    if (!FacetFiltersForm || FacetFiltersForm.faPersistencePatched) return false;
    if (typeof FacetFiltersForm.renderFilters !== 'function') return false;

    const originalRenderFilters = FacetFiltersForm.renderFilters;

    FacetFiltersForm.renderFilters = function renderFiltersWithPersistence(html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const fetchedElements = [...parsedHTML.querySelectorAll(FILTER_SELECTOR)];
      const fetchedIds = new Set(fetchedElements.map((element) => element.id).filter(Boolean));
      const currentElements = [...document.querySelectorAll(FILTER_SELECTOR)];

      const preserved = currentElements
        .filter((element) => element.id && !fetchedIds.has(element.id))
        .map((element) => {
          const parent = element.parentElement;
          const siblings = parent ? [...parent.children] : [];
          const currentIndex = siblings.indexOf(element);
          const nextReturnedSibling = siblings
            .slice(currentIndex + 1)
            .find((sibling) => sibling.id && fetchedIds.has(sibling.id));

          const record = {
            element,
            parentId: parent?.id || '',
            nextId: nextReturnedSibling?.id || '',
          };

          element.remove();
          return record;
        });

      originalRenderFilters.call(this, html, event);

      preserved.forEach(({ element, parentId, nextId }) => {
        if (!parentId || document.getElementById(element.id)) return;

        const parent = document.getElementById(parentId);
        if (!parent) return;

        const next = nextId ? document.getElementById(nextId) : null;
        const footer = parent.querySelector(':scope > .mobile-facets__footer');

        if (next && next.parentElement === parent) {
          parent.insertBefore(element, next);
        } else if (footer) {
          parent.insertBefore(element, footer);
        } else {
          parent.appendChild(element);
        }

        markUnavailable(element);
      });

      document.querySelectorAll(FILTER_SELECTOR).forEach((element) => {
        if (fetchedIds.has(element.id)) markAvailable(element);
      });

      document.dispatchEvent(
        new CustomEvent('fa:facets-updated', {
          detail: { fetchedIds: [...fetchedIds] },
        }),
      );
    };

    FacetFiltersForm.faPersistencePatched = true;
    return true;
  };

  if (!patch()) {
    window.addEventListener('DOMContentLoaded', patch, { once: true });
  }
})();
